<template>
    <section class="c-o-contact-form">
        <div class="c-o-contact-form__inner">
            <div class="c-o-contact-form__title" v-if="formTitle">
                <h3>{{formTitle}}</h3>
            </div>
            <div class="c-o-contact-form__message" v-if="errorMessages.length > 0">
                <message type="error">
                    <div class="o-wysiwyg">
                        <ul>
                            <li v-for="(message, index) in errorMessages" :key="`message-${index}`">{{message}}</li>
                        </ul>
                    </div>
                </message>
            </div>
            <div class="c-o-contact-form__message" v-else-if="sendState === 'success'">
                <message type="success">
                    <p>{{successMessage}}</p>
                </message>
            </div>
            <div
                class="c-o-contact-form__block c-o-contact-form__block--half"
                :class="{'c-o-contact-form__block--invalid-animation': errors.company}"
            >
                <div class="c-o-contact-form__input">
                    <input-text
                        :icon="'home'"
                        :label="'Företag'"
                        :id="10"
                        :placeholder="'Ex. Bygg AB'"
                        v-model="company"
                        name="membership-company"
                        :invalid="errors.company"
                        :required="true">
                    </input-text>
                </div>
            </div>
            <div
                class="c-o-contact-form__block c-o-contact-form__block--half"
                :class="{'c-o-contact-form__block--invalid-animation': errors.name}"
            >
                <div class="c-o-contact-form__input">
                    <input-text
                        :icon="'person'"
                        :label="'Namn'"
                        :id="11"
                        :placeholder="'Ex. Camilla Berg'"
                        v-model="name"
                        name="membership-name"
                        :invalid="errors.name"
                        :required="true">
                    </input-text>
                </div>
            </div>
            <div
                class="c-o-contact-form__block c-o-contact-form__block--half"
                :class="{'c-o-contact-form__block--invalid-animation': errors.phone}"
            >
                <div class="c-o-contact-form__input">
                    <input-phone
                        :icon="'phone'"
                        :label="'Telefon'"
                        :id="12"
                        :placeholder="'Ex. 070-123 45 67'"
                        name="membership-phone"
                        v-model="phone"
                        :invalid="errors.phone"
                        :required="true">
                    </input-phone>
                </div>
            </div>
            <div
                class="c-o-contact-form__block c-o-contact-form__block--half"
                :class="{'c-o-contact-form__block--invalid-animation': errors.email}"
            >
                <div class="c-o-contact-form__input">
                    <input-email
                        :icon="'mail'"
                        :label="'E-post'"
                        :id="13"
                        :placeholder="'Ex. camilla.berg@byggab.se'"
                        v-model="email"
                        name="membership-email"
                        :invalid="errors.email"
                        :required="true">
                    </input-email>
                </div>
            </div>
            <div class="c-o-contact-form__block">
                <success-button :currentState="sendState" @buttonClicked="send" :customStates="states"></success-button>
            </div>
        </div>
    </section>
</template>

<script>
    import { mapActions } from 'vuex'
    import {
        SEND_MEMBERSHIP_MAIL,
        GET_SEND_ERROR
    } from '../../../../store/store-models/send-mail-model.js'
    import { setErrors, hasErrors, isEmailValid, isPhoneValid } from '../../../../helpers/error-validation';
    import { timeout } from '../../../../helpers';

    import InputText from '../../atoms/form/AtomInputText.vue'
    import InputPhone from '../../atoms/form/AtomInputPhone.vue'
    import InputEmail from '../../atoms/form/AtomInputEmail.vue'
    import TextArea from '../../atoms/form/AtomTextarea.vue'
    import SuccessButton from '../../atoms/AtomSuccessButton.vue'

    export default {
        props: {
            content: {
                type: Object,
            },
        },
        components: {
            InputText,
            InputPhone,
            InputEmail,
            TextArea,
            SuccessButton
        },
        data() {
            const { title } = this.content
            return {
                formTitle: title,
                company: '',
                name: '',
                phone: '',
                email: '',
                message: '',
                errorMessages: [],
                successMessage: 'Dina uppgifter har skickats! Vi återkommer med mer information.',
                errors: {
                    company: false,
                    name: false,
                    phone: false,
                    email: false
                },
                states: {
                    default: {
                        label: 'Skicka',
                    },
                    processing: {
                        label: 'Skickar',
                    },
                    success: {
                        label: 'Skickat!',
                    }
                },
                sendState: 'default'
            }
        },
        computed: {
            sendError: function() {
                return this.$store.getters[GET_SEND_ERROR]('sendMembership');
            },
        },
        methods: {
            ...mapActions({
                sendMembership: SEND_MEMBERSHIP_MAIL
            }),
            async send() {
                this.errorMessages = [];
                setErrors(this.errors, ['company', 'name', 'phone', 'email'], false);

                // check if any required field is empty
                if( !this.company || !this.name || !this.phone || !this.email ) {
                    ['company', 'name', 'phone', 'email'].forEach(model => {
                        const value = !this[model] ? true : false;
                        setErrors(this.errors, [model], value);
                    });
                    this.errorMessages.push('Fyll i alla obligatoriska fält');
                }

                //check if the email adress is valid
                if( !isEmailValid(this.email) ) {
                    this.errorMessages.push('Fyll i en korrekt mailadress');
                    setErrors(this.errors, ['email'], true);
                }

                if( !isPhoneValid(this.phone) ) {
                    this.errorMessages.push('Fyll i ett korrekt telefonnummer. (Ex. 070-123 45 67)');
                    setErrors(this.errors, ['phone'], true);
                }

                if( hasErrors(this.errors, ['company', 'name', 'phone', 'email'])  ) {
                    this.sendState = 'error';
                    return;
                }

                this.sendState = 'processing';

                const data = {
                    'Company': this.company,
                    'Name': this.name,
                    'Phone': this.phone,
                    'Email': this.email
                }

                try {
                    await this.sendMembership(data);
                    this.sendState = 'success';
                } catch(e) {
                    this.errorMessages.push(this.sendError);
                    this.sendState = 'error';
                }

                await timeout();
                this.sendState = 'default';
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/components/organisms/page-sections/OrganismSectionContactForm.vue